import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
//import { ReportService } from '../../report.service';
import { DistributionService } from '../../distribution.service';

@Component({
  standalone: false,
  selector:    'app-reconciliation-report-modal',
  templateUrl: './reconciliation-report-modal.component.html',
  styleUrls:   ['./reconciliation-report-modal.component.scss'],
})
export class ReconciliationReportModalComponent implements OnInit {
  public form: UntypedFormGroup;
  public isLoading = 0;

  constructor(
      private toast: ToastrService,
      private reportService: DistributionService,
      private fb: UntypedFormBuilder,
      public dialogRef: MatDialogRef<ReconciliationReportModalComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      start_date: [null, Validators.required],
      end_date:   [null, Validators.required],
    });
  }

  sendReportData() {
    if (!this.form.valid) {
      return;
    }

    const requestData = {
      start_date: this.form.value.start_date.toISOString(),
      end_date:   this.form.value.end_date.toISOString(),
    };
    this.isLoading++;

    this.reportService.generateReconciliationDistReport(requestData).pipe(finalize(() => this.isLoading--))
        .subscribe(res => {
              // const fileName = 'sales_report' + moment().format('YYYY-MM-DD_HH-mm') + '.csv';
              // saveAs(res.body, fileName);
              this.dialogRef.close(true);
              this.toast.success(res.message);

            },
            err => console.error(err),
        ); 
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
